import { BROWSER_MODEL_FALLBACK_ID, BROWSER_MODEL_ID, BROWSER_MODEL_QUALITY_ID } from '../ai/browserModel';
import { chooseAutomaticInterpretation, describeInterpretationEnvironment, type InterpretationEnvironment } from '../ai/deviceRouting';
import type { ProviderPreset } from '../ai/providers';
import { Icon } from './Icon';

export function InterpretationModeCard({ preset, environment }: { preset: ProviderPreset; environment: InterpretationEnvironment }) {
  if (preset === 'auto') {
    const automatic = chooseAutomaticInterpretation(environment);
    return (
      <div className="browser-model-note interpretation-mode-card">
        <div className="browser-model-title"><strong>自动适配（推荐）</strong><span>先识别设备，再选择最稳方式</span></div>
        <p className="browser-model-brief"><Icon name="check" size={15} />{describeInterpretationEnvironment(environment)}</p>
        <div className="platform-mode-grid" aria-label="各平台自动解读方式">
          <span><b>手机 / 平板</b><small>免费规则解读<br />不下载模型</small></span>
          <span><b>电脑网页</b><small>条件合适用轻量模型<br />不合适自动回退</small></span>
          <span><b>手动选择</b><small>可改用本地优质模型<br />或自己的 API</small></span>
        </div>
        <small className="mode-result">本次自动选择：{automatic === 'rules' ? '免费规则解读（零下载）' : 'Qwen3 0.6B 轻量本地模型'}</small>
      </div>
    );
  }

  if (preset === 'rules') {
    return (
      <div className="browser-model-note interpretation-mode-card">
        <div className="browser-model-title"><strong>免费规则解读</strong><span>所有常见手机和电脑均可使用</span></div>
        <p className="browser-model-brief"><Icon name="check" size={15} />零模型下载 · 零 API · 200字以内 · 支持关联追问</p>
        <small>直接读取程序已经算出的盘面字段，并按事业、感情、财运、时间、原因和下一步等问题组织回答。它不会调用大模型，也不会上传内容。</small>
      </div>
    );
  }

  if (preset === 'browser' || preset === 'browserQuality') {
    const quality = preset === 'browserQuality';
    return (
      <div className="browser-model-note interpretation-mode-card">
        <div className="browser-model-title"><strong>{quality ? '优质本地模型' : '轻量本地模型'}</strong><span>浏览器内运行 · 无需 API Key</span></div>
        <p className="browser-model-brief"><Icon name="check" size={15} />{quality ? '首次下载约 1 GB · 运行时约 2.1 GB · 推荐电脑使用' : '首次下载约 350 MB · 运行时约 1.4 GB · 推荐普通电脑使用'}</p>
        <details className="browser-model-details">
          <summary>查看本机模型说明</summary>
          <small>首选模型：{quality ? BROWSER_MODEL_QUALITY_ID : BROWSER_MODEL_ID}。</small>
          <small>{quality ? `若内存或 GPU 不足，会依次切换 ${BROWSER_MODEL_ID} 和 ${BROWSER_MODEL_FALLBACK_ID}。` : `若 GPU 不兼容，会自动切换备用模型：${BROWSER_MODEL_FALLBACK_ID}。`}</small>
          <small>首次点击“开始解读”才会下载；模型完成后优先读取本机缓存。</small>
          <small>当前环境：{environment.webGpu ? '已检测到 WebGPU' : '未检测到 WebGPU，点击前会直接提示'}；{environment.secureContext ? '安全上下文正常' : '当前页面不是安全上下文'}。</small>
          <small>盘面和图片只在当前浏览器处理，不上传到模型服务。</small>
        </details>
      </div>
    );
  }

  return null;
}
